var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"pictures\">\n<div class=\"pictures__picture\" ng-class=\"{active: picture === create.currentPicture}\" ng-repeat=\"picture in create.pictures\">\n<img ng-src=\"{{picture}}\" ng-click=\"create.setPicture($index)\"/>\n</div>\n</div>\n";
var id1="create/template/tabContentPicture.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;